/**
 * 区分 itemPhaseType（case_items.item_phase_type）
 * 出典：同上
 * 【仮置き】入力文書に値が無い。業務側の確認で差し替える
 */
export const ITEM_PHASE_TYPE_VALUES = ['proposal', 'estimate', 'ordered', 'lost'] as const;

export type ItemPhaseType = (typeof ITEM_PHASE_TYPE_VALUES)[number];

export const ITEM_PHASE_TYPE_LABELS: Readonly<Record<ItemPhaseType, string>> = {
  proposal: '提案',
  estimate: '見積',
  ordered: '成約',
  lost: '失注',
};

/**
 * 旧の商品のフェーズの札の色（旧 ActivityDetail の PRODUCT_PHASES：地 bg・字 color）。274。
 * 見積（estimate）は新規追加の値なので旧の「打ち合わせ調整」と同じ灰色にする
 */
export const ITEM_PHASE_TYPE_COLORS: Readonly<Record<ItemPhaseType, { color: string; bg: string }>> = {
  proposal: { color: '#856404', bg: '#fff3cd' },
  estimate: { color: '#6c757d', bg: '#e9ecef' },
  ordered: { color: '#28a745', bg: '#d4edda' },
  lost: { color: '#dc3545', bg: '#f8d7da' },
};
